import React from 'react'
import styled from 'styled-components'
import { useDutyModalStore } from '../../store/dutyModal'

const SearchResultNotFound: React.FC = () => {
  const variables = useDutyModalStore((store) => store.variables)
  return (
    <StyledWrapper>
      {variables?.filterBy?.query && (
        <>
          <h4 className="not-found-message">
            <span style={{ color: '#01a0ff' }}>{variables.filterBy.query}</span>{' '}
            에 대한 검색결과가 없습니다.
          </h4>
          <p className="search-tip">
            단어의 철자가 정확한지 확인하세요.
            <br /> 다른 검색어를 사용해보세요.
            <br /> 더 일반적인 검색어를 사용해 보세요.
          </p>
        </>
      )}
      {!variables?.filterBy?.query && (
        <h4 className="not-found-keyword">등록된 공고가 없습니다.</h4>
      )}
    </StyledWrapper>
  )
}

export default SearchResultNotFound

const StyledWrapper = styled.div`
  /* width: 100%; */
  /* height: 100%; */
  margin: auto;
  padding: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  text-align: center;
  .not-found-message {
    color: #333333;
    font-weight: 500;
    font-size: 20px;
    margin-bottom: 10px;
  }
  .not-found-keyword {
    color: #999999;
    font-weight: 500;
  }
  .search-tip {
    font-size: 16px;
    color: #999999;
  }
`
